// extracted by mini-css-extract-plugin
export default {"r_l":"ff831e7780 _4502154728","t":"_5dbaf9e14e"};